import { FC } from "react"

import { useTranslation } from "react-i18next"

import { CurrencyFiatLimit } from "services/settings/type"

import { LimitsDepositFields } from "./LimitsDepositFields"
import { LimitsWithdrawalFields } from "./LimitsWithdrawalFields"

interface LimitsCurrencyCardProps {
  code: string
  value: CurrencyFiatLimit
  onUpdate: (path: string[], value: string) => void
  onRemove: (code: string) => void
  disabled?: boolean
}

export const LimitsCurrencyCard: FC<LimitsCurrencyCardProps> = ({ code, value, onUpdate, onRemove, disabled }) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <div className="border rounded-lg border-black/10 dark:border-white/10 p-5">
      <div className="flex items-center justify-between mb-4">
        <span className="text-base font-semibold text-[rgba(6,7,21,1)] dark:text-white">{code}</span>
        <button
          type="button"
          onClick={() => onRemove(code)}
          disabled={disabled}
          className="text-sm font-medium text-red-500 hover:text-red-600 disabled:opacity-50"
        >
          {t("settings.limits.perCurrency.remove")}
        </button>
      </div>

      <h5 className="text-md font-semibold mt-2 mb-1 text-[rgba(6,7,21,1)] dark:text-white">
        {t("settings.limits.perCurrency.depositLimits", { code })}
      </h5>
      <LimitsDepositFields
        idPrefix={`${code}-deposit`}
        basePath={["currencyLimits", code, "deposit"]}
        values={value.deposit}
        typeLabel={t("settings.limits.types.deposit")}
        currencyCode={code}
        onUpdate={onUpdate}
        disabled={disabled}
      />

      <h5 className="text-md font-semibold mt-4 mb-1 text-[rgba(6,7,21,1)] dark:text-white">
        {t("settings.limits.perCurrency.withdrawalLimits", { code })}
      </h5>
      <LimitsWithdrawalFields
        idPrefix={`${code}-withdrawal`}
        basePath={["currencyLimits", code, "withdrawal"]}
        values={value.withdrawal}
        typeLabel={t("settings.limits.types.withdrawal")}
        currencyCode={code}
        onUpdate={onUpdate}
        disabled={disabled}
      />
    </div>
  )
}
